// This file is automatically generated. Do not edit manually.

import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProductionJobQueueOperationActionApi {
	export async function startOperations(args: {
		shopOrderOperationIds: Array<number>;
		setShopOrderOperationProductionLine?: boolean;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/jobQueueOperationActions/startOperations",
			method: "POST",
			data: {
				shopOrderOperationIds: args.shopOrderOperationIds,
				setShopOrderOperationProductionLine: args.setShopOrderOperationProductionLine,
			},
		});
		return response as void;
	}

	export async function revertStartOperations(args: { shopOrderOperationIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/jobQueueOperationActions/revertStartOperations",
			method: "POST",
			data: {
				shopOrderOperationIds: args.shopOrderOperationIds,
			},
		});
		return response as void;
	}

	export async function hasWorkcenterIncompleteOperations(args: { shopOrderId: number }): Promise<boolean> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/jobQueueOperationActions/hasWorkcenterIncompleteOperations",
			method: "POST",
			data: {
				shopOrderId: args.shopOrderId,
			},
		});
		return response as boolean;
	}

	export async function completeOperations(args: { shopOrderOperationIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/jobQueueOperationActions/completeOperations",
			method: "POST",
			data: {
				shopOrderOperationIds: args.shopOrderOperationIds,
			},
		});
		return response as void;
	}

	export async function revertCompleteOperations(args: { shopOrderOperationIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/jobQueueOperationActions/revertCompleteOperations",
			method: "POST",
			data: {
				shopOrderOperationIds: args.shopOrderOperationIds,
			},
		});
		return response as void;
	}

	export async function getJobQueuePickingList(args: {
		shopOrderIds: Array<number>;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/jobQueueOperationActions/getJobQueuePickingList",
			method: "POST",
			data: {
				shopOrderIds: args.shopOrderIds,
			},
		});
		return response as FrontendDownloadFileHandle;
	}
}
